import Vue from 'vue'
import _ from 'lodash'

const citiesAll = payload => {
  return axios.get(`${Vue.config.server}/${Vue.config.modules.crm.api.cities.all}`, { params: payload })
}

/**
 * @description Сортировка городов по алфавиту и обработка исключения, Санкт-Петербург всегда первый в списке
 * @param cities {Array}
 * @return cities {Array}
 */
const sortCities = cities => {
  const indexSpb = cities.findIndex(city => city.name === 'Санкт-Петербург')
  const spb = cities.splice(indexSpb, 1)
  cities.sort((a, b) => {
    if (a.name < b.name) return -1
    if (a.name > b.name) return 1
    if (a.name === b.name) return 0
  })
  cities.unshift(...spb)
  return cities
}

export default {
  GET_CITIES: ({ commit, state }, { params = {}, callback = null }) => {
    return citiesAll(params).then(response => {
      const data = response.data.data
      const cities = _.map(data.items, item => {
        item.opened = true
        return item
      })
      if (params.reset) {
        commit('setCities', cities)
      }

      if (!params.reset) {
        commit('setCities', state.cities.concat(cities))
      }

      commit('setCityFilters', data.filters)

      callback ? callback(_.cloneDeep(cities)) : null
    })
  },
}
